// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_modal__qgWXm {
  border-radius: 2px;
  box-shadow: 1px 2px 10px 0 rgba(0, 0, 0, 0.3);
  min-width: 300px;
  animation: Modal_show-modal__f7Syw 0.5s ease-in-out;
}
.Modal_modal__qgWXm.Modal_hide__Qg7Zu {
  animation: Modal_hide-modal__\\+1ULf 0.3s ease-in-out both;
}
.Modal_modal__qgWXm img {
  margin-top: 24px;
}

@keyframes Modal_show-modal__f7Syw {
  0% {
    transform: scale(0);
  }
  60% {
    transform: scale(1.1);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes Modal_hide-modal__\\+1ULf {
  0% {
    transform: scale(1);
  }
  20% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(0);
  }
}
.Modal_content__S73sE {
  box-sizing: border-box;
  padding: 10px;
}

.Modal_header__3m-qf {
  box-sizing: border-box;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
}

.Modal_footer__12G0S {
  box-sizing: border-box;
  padding: 5px 10px 5px 10px;
}`, "",{"version":3,"sources":["webpack://./src/_common/components/Modal/Modal.module.scss","webpack://./src/_common/scss/_variables.scss"],"names":[],"mappings":"AAIA;EACE,kBAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;AAHF;AAKE;EACE,yDAAA;AAHJ;AAME;EACE,gBAAA;AAJJ;;AAQA;EACE;IACE,mBAAA;EALF;EAQA;IACE,qBAAA;EANF;EASA;IACE,sBAAA;EAPF;EAUA;IACE,mBAAA;EARF;AACF;AAWA;EACE;IACE,mBAAA;EATF;EAYA;IACE,qBAAA;EAVF;EAaA;IACE,mBAAA;EAXF;AACF;AAcA;EACE,sBAAA;EACA,aChDU;ADoCZ;;AAeA;EACE,sBAAA;EACA,kBCrDU;EDsDV,mBCtDU;EDuDV,gBCxDU;AD4CZ;;AAeA;EACE,sBAAA;EACA,0BAAA;AAZF","sourcesContent":["@use 'sass:color';\n@import '@common/scss/_variables';\n@import '@common/scss/_colors';\n\n.modal {\n  border-radius: 2px;\n  box-shadow: 1px 2px 10px 0 rgb(0 0 0 / 0.3);\n  min-width: 300px;\n  animation: show-modal 0.5s ease-in-out;\n\n  &.hide {\n    animation: hide-modal 0.3s ease-in-out both;\n  }\n\n  img {\n    margin-top: 24px;\n  }\n}\n\n@keyframes show-modal {\n  0% {\n    transform: scale(0);\n  }\n\n  60% {\n    transform: scale(1.1);\n  }\n\n  80% {\n    transform: scale(0.95);\n  }\n\n  100% {\n    transform: scale(1);\n  }\n}\n\n@keyframes hide-modal {\n  0% {\n    transform: scale(1);\n  }\n\n  20% {\n    transform: scale(1.1);\n  }\n\n  100% {\n    transform: scale(0);\n  }\n}\n\n.content {\n  box-sizing: border-box;\n  padding: $padding-m;\n}\n\n.header {\n  box-sizing: border-box;\n  padding-left: $padding-m;\n  padding-right: $padding-m;\n  padding-top: $padding-s;\n}\n\n.footer {\n  box-sizing: border-box;\n  padding: $padding-s $padding-m $padding-s $padding-m;\n}\n","@import './colors';\n\n$border-radius: 3px !default;\n$border-radius-extra: 8px !default;\n$padding-s: 5px;\n$padding-m: 10px;\n$padding-l: 20px;\n$padding-xl: 30px;\n$padding-xxl: 40px;\n$margin-s: 5px;\n$margin-m: 10px;\n$margin-l: 20px;\n$margin-xl: 30px;\n$margin-xxl: 40px;\n$margin-xxxl: 50px;\n$shadow-depth: 1;\n$base-font-size: 14px !default;\n$base-line-height: 17px !default;\n$base-unit: 'em' !default;\n$base-font-family: 'Source Sans Pro', sans-serif !default;\n$h1-font-size: 2 * $base-font-size !default;\n$h2-font-size: 1.5 * $base-font-size !default;\n$h3-font-size: 1.17 * $base-font-size !default;\n$h4-font-size: 1 * $base-font-size !default;\n$h5-font-size: 0.83 * $base-font-size !default;\n$h6-font-size: 0.67 * $base-font-size !default;\n$indent-amount: 40px !default;\n$normalize-vertical-rhythm: false !default;\n$default-border: solid 1px $default-border-color;\n$navbar-z-index: 10000;\n$top-most-z-index: 100000;\n$navbar-height: 67px;\n$navbar-bg: #d9d9d9;\n$default-navbar-shadow: 0 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-statscard-shadow: 3px 3px 3px -1px rgb(0 0 0 / 0.1);\n$default-mainfilters-shadow: inset -3px 0 3px rgb(0 0 0 / 0.1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `Modal_modal__qgWXm`,
	"show-modal": `Modal_show-modal__f7Syw`,
	"hide": `Modal_hide__Qg7Zu`,
	"hide-modal": `Modal_hide-modal__+1ULf`,
	"content": `Modal_content__S73sE`,
	"header": `Modal_header__3m-qf`,
	"footer": `Modal_footer__12G0S`
};
export default ___CSS_LOADER_EXPORT___;
